module.exports = __webpack_public_path__ + "static/media/Monkey.ade42cc1.webm";